import React, { FC, PropsWithChildren, useRef } from 'react';
import classNames from 'classnames';
import useLocalStorage from '@rehooks/local-storage';

import Container from 'components/common/Container';
import { SongPlayBarContextProvider } from 'components/context/SongPlayBarContext';

import { useObserveVisible } from 'services/common/domHelpers';

import { TimelineLayoutProps } from './interfaces';

import useStyles from './style';

const TimelineLayout: FC<PropsWithChildren<TimelineLayoutProps>> = ({
  left,
  right,
  className,
  children,
}) => {
  const classes = useStyles();

  const [isSiderClosed] = useLocalStorage<boolean>('isSiderClosed', false);

  const ref = useRef<HTMLDivElement | null>(null);

  useObserveVisible(ref, () => {
    const eventLayout = document.getElementById('eventLayout');
    eventLayout?.setAttribute('scrolled', 'true');
  });

  return (
    <SongPlayBarContextProvider>
      <div className={classNames('timelineLayout', classes.timelineLayout, className)} ref={ref}>
        {children}
        <Container>
          <div className={classes.content}>
            <div className={classes.left}>{left}</div>
            <div
              className={classNames(classes.right, 'subTitle', {
                'sider-opened': !isSiderClosed,
              })}
            >
              {right}
            </div>
          </div>
        </Container>
      </div>
    </SongPlayBarContextProvider>
  );
};

export default TimelineLayout;
